// components/InputWithDebounce.tsx
"use client";
import { useState, useRef, useEffect, ChangeEvent } from "react";
import { Input, InputGroup } from "@chakra-ui/react";

interface DebouncedInputProps {
  onChange: (value: string) => void;
  value?: string;
  delay?: number;
  group?: boolean;
  [key: string]: any;
}

function DebouncedInput({
  onChange,
  value = "",
  delay = 800,
  group = true,
  ...props
}: DebouncedInputProps) {
  const [inputValue, setInputValue] = useState<string>(value);
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Effect to sync external value changes with internal state
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(() => {
      onChange(newValue);
    }, delay);
  };
  return group ? (
    <InputGroup>
      <Input {...props} value={inputValue} onChange={handleChange} />
    </InputGroup>
  ) : (
    <Input {...props} value={inputValue} onChange={handleChange} />
  );
}

export default DebouncedInput;
